import { render } from "./KitDetail.vue?vue&type=template&id=bef7c9f2"
import script from "./KitDetail.vue?vue&type=script&lang=js"
export * from "./KitDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__